enum BreadcrumbName {
  FlightControl = 'FlightControl',

  // Campaigns
  CampaignsLibrary = 'CampaignsLibrary',
  CampaignPage = 'CampaignPage',

  // Campaign Workflow
  CampaignHome = 'CampaignHomeTab',
  CampaignBrief = 'CampaignBriefTab',
  CampaignConceptPlan = 'CampaignConceptPlanTab',
  CampaignLogic = 'CampaignLogicTab',
  CampaignInsights = 'CampaignInsightsTab',
  CampaignAdSets = 'CampaignAdSetsTab',
  CampaignAds = 'CampaignAdsTab',

  // Creative Templates
  CreativeTemplatesLibrary = 'CreativeTemplatesLibrary',
  CreativeTemplatePage = 'CreativeTemplatePage',
  SmartCreativesLibrary = 'SmartCreativesLibrary',
  SmartCreativePage = 'SmartCreativePage',
  SmartCreativeAdBuilder = 'SmartCreativeAdBuilder',
  CreativeTemplateHomeTab = 'CreativeTemplateHomeTab',
  AdBuilder = 'AdBuilder',
  TemplateMapping = 'TemplateMapping',

  // Creatives
  CreativesLibrary = 'CreativesLibrary',
  CreativePage = 'CreativePage',

  // Analytics
  Dashboard = 'Dashboard',

  // Brand Guidelines Page
  BrandGuidelinesPage = 'BrandGuidelinesPage',
  BrandAssets = 'BrandAssets',
  BrandPersonas = 'BrandPersonas',

  // Target Platforms
  TargetPlatforms = 'TargetPlatforms',
  VideoSettings = 'VideoSettings',

  //Product Feeds Page
  ProductFeedPage = 'ProductFeedPage',
  CatalogFeedTab = 'CatalogFeedTab',
  // Content Feeds
  ContentFeedsLibrary = 'ContentFeedsLibrary',
  ContentFeedPage = 'ContentFeedPage',

  // DSP Library 2
  DspLibrary2 = 'DspLibrary2',

  // Widgets
  WidgetEditPage = 'WidgetEditPage',
}

enum BreadcrumbDepthOrder {
  DeepestFirst = 'deepestFirst',
  ShallowestFirst = 'shallowestFirst',
}

export {BreadcrumbDepthOrder, BreadcrumbName};
